import * as React from "react";
import DeliveryIndicatorContext from "./context.js";
const DeliveryIndicatorProvider = ({
  children,
  config,
  deliveryInfo
}) => {
  const value = React.useMemo(
    () => ({
      config,
      deliveryInfo
    }),
    [config, deliveryInfo]
  );
  return /* @__PURE__ */ React.createElement(DeliveryIndicatorContext.Provider, { value }, children);
};
export {
  DeliveryIndicatorProvider
};
//# sourceMappingURL=provider.js.map
